import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitName',
})
export class SplitNamePipe implements PipeTransform {
  transform(userName: string, flag: 'surname' | 'name'): any {
    const result = userName.split(' ');
    const surname = result[result.length - 1];
    const name = result.splice(0, result.length - 1).toString();

    if (flag === 'name') {
      return name;
    } else if (flag === 'surname') {
      return surname;
    }
  }
}
